import { render, staticRenderFns } from "./CommunityVote.vue?vue&type=template&id=70aed000&scoped=true&"
import script from "./CommunityVote.vue?vue&type=script&lang=js&"
export * from "./CommunityVote.vue?vue&type=script&lang=js&"
import style0 from "./CommunityVote.vue?vue&type=style&index=0&id=70aed000&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aed000",
  null
  
)

export default component.exports